module.exports = require("core-js-pure/stable/weak-map");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/weak-map.js
// module id = 674
// module chunks = 25